import { render, staticRenderFns } from "./InputColour.vue?vue&type=template&id=0cbf93f4&"
import script from "./InputColour.vue?vue&type=script&lang=js&"
export * from "./InputColour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports